import React from 'react';
import OrderListTable from "../../../components/OrderListTable";
import {ShippingStatus} from "../../../../types/order";
import {ProductType} from "../../../../types/product";

export const ExchangeBooksOrderPage = () => {
    return <OrderListTable status={ShippingStatus.CHANGE} type={ProductType.BOOK}/>;
}
